import {Component, Injector} from '@angular/core';
import { exhaustMap } from 'rxjs/operators';
import { ApComplexModal, CoreUiModule } from 'webcommon/core-ui';
import {
  GuidStrValue,
  ImoTermDto,
  asyncClickHandlerP,
  SessionRequest_Create,
} from 'webcommon/shared';
import {TerminologySearchComponent} from '../terminology-search/terminology-search.component';
import {TerminologyRepository} from 'webcommon/webapi';
import { TerminologyIframeDelegate } from '../TerminologyIframeDelegate';

@Component({
  selector: 'ap-terminology-search-modal',
  standalone: true,
  imports: [CoreUiModule, TerminologySearchComponent],
  templateUrl: './terminology-search-modal.component.html',
  styleUrls: ['./terminology-search-modal.component.less'],
  providers: [
    TerminologyIframeDelegate.provideSubClass(TerminologyIframeDelegate),
  ],
})
export class TerminologySearchModalComponent extends ApComplexModal<ImoTermDto[]> {
  sessionRequest: SessionRequest_Create;
  currentSessionToken?: GuidStrValue;
  codeSelected$ = this.terminologyIframeDelegate.codeSelected$();

  static isSupportedFn() {
    return TerminologySearchComponent.isSupportedFn();
  }

  constructor(
    elementInjector: Injector,
    private terminologyRepository: TerminologyRepository,
    private terminologyIframeDelegate: TerminologyIframeDelegate,
  ) {
    super(elementInjector);
    this.terminologyIframeDelegate.afterSave$().pipe(
      exhaustMap(async (value) => {
        if (value.data.data) {
          // true for save success, close normally
          await this.normalClose();
        } else {
          // false for cancel
          this.apUserCancel();
        }
      }),
      this.takeUntilDestroy(),
    ).subscribe();
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  tryClose = asyncClickHandlerP(async () => {
    if (!this.sessionRequest.IsSingleSelect) {
      // not single select, so close normally
      await this.normalClose();
      return;
    }

    // if it is single select, then we need to send messages to the iframe to close
    await this.terminologyIframeDelegate.tryStartSave();
  });

  private async normalClose(): Promise<void> {
    if (!this.currentSessionToken) {
      this.apUserCancel();
      return;
    }
    const terms = await this.terminologyRepository.getSessionTerms(this.currentSessionToken).toPromise();
    if (!terms.length) {
      // If no terms selected, treat it as a cancel.
      // I guess another option would be to just not close or cancel the modal at all in this case.
      this.apUserCancel();
      return;
    }
    this.apClose(terms);
  }
}
